<template>
  <!-- 添加在线商城产品 -->
  <div class="container">
    <div class="vue padHorizontal10">
      <div class="header flex flexJc-sb flexAi-c">
        <div class="text">{{ title }}</div>
        <div class="padR10 ">
          <el-button size="mini" @click="goBack" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content flex flexAi-c">
        <el-form
          :rules="rules"
          size="small"
          ref="formShop"
          :model="formShop"
          label-width="80px"
        >
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="formShop.name"></el-input>
          </el-form-item>
          <el-form-item
            v-if="routeData === ''"
            label="商品规格"
            prop="unitName"
          >
            <el-input v-model="formShop.unitName"></el-input>
          </el-form-item>
          <el-form-item label="商品图片" prop="imageUpload">
            <div class="image">
              <el-upload
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :file-list="fileList"
                :on-remove="handleRemove"
                :limit="1"
                :http-request="uploadSectionFile"
                :on-exceed="handleExceed"
              >
                <div class="addimage flex flexColumn flexAi-c flexJc-c">
                  <el-image
                    class="image flex"
                    :src="require('@/assets/ProductManage/tjtp.png')"
                  ></el-image>
                  <span class="text">添加图片</span>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item v-if="routeData === ''" label="商品库存" prop="stock">
            <el-input-number
              size="small"
              v-model="formShop.stock"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item v-if="routeData === ''" label="积分价格" prop="price">
            <el-input-number
              size="small"
              :step="0.1"
              v-model="formShop.price"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="商品详情" prop="dtl">
            <vue-ueditor-wrap
              class="ueditor"
              v-model="formShop.dtl"
              :config="myConfig"
            ></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('formShop')"
              >确定</el-button
            >
            <el-button @click="goBack">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { apiAddPoint, apiEditGoods } from '@/api/ProductManage'
import { apiUploadByBase64 } from '@/api/uploading'

import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
let _self
export default {
  name: '',
  props: [''],

  data() {
    return {
      title: '',
      uploadActionUrl: '',
      routeData: '', // 编辑数据
      formShop: {
        name: '',
        unitName: '',
        stock: '',
        price: '',
        dtl: '',
        imageUpload: ''
      },
      rules: {
        name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        unitName: [
          { required: true, message: '请输入产品规格', trigger: 'blur' }
        ],
        img: [{ required: true, message: '请输入产品图片', trigger: 'blur' }],
        stock: [{ required: true, message: '请输入产品库存', trigger: 'blur' }],
        price: [{ required: true, message: '请输入积分价格', trigger: 'blur' }],
        dtl: [{ required: true, message: '请输入产品简介', trigger: 'blur' }]
      },
      fileList: [],
      imageUrl: '',
      dialogVisible: false,
      disabled: false,
      myConfig: {
        UEDITOR_HOME_URL: '/UEditor/',
        serverUrl: '',
        // 工具栏是否可以浮动
        autoFloatEnabled: false
      }
    }
  },
  components: {
    VueUeditorWrap
  },
  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    if (this.$route.query.info !== undefined) {
      this.routeData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      this.edit()
      this.title = '编辑商城产品'
    } else {
      this.title = '添加商城产品'
    }
    console.log(this.routeData)
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    edit() {
      this.formShop.name = this.routeData.name
      this.formShop.unitName = this.routeData.unitName
      this.formShop.stock = this.routeData.stock
      this.formShop.price = this.routeData.price
      this.formShop.dtl = this.routeData.dtl
      this.formShop.imageUpload = this.routeData.pic
      this.fileList = [{ url: this.baseImage + this.routeData.pic }]
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 不为空走编辑
          if (this.routeData !== '') {
            apiEditGoods({
              id: this.routeData.id,
              name: this.formShop.name,
              pic: this.formShop.imageUpload,
              dtl: this.formShop.dtl
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.formShop = {
                  name: '',
                  unitName: '',
                  stock: '',
                  price: '',
                  dtl: '',
                  imageUpload: ''
                }
                this.fileList = []
                this.$router.go(-1)
              } else if (res.status === 1) {
                this.$Me(res.msg)
              }
            })
          } else {
            apiAddPoint({
              name: this.formShop.name,
              pic: this.formShop.imageUpload,
              dtl: this.formShop.dtl,
              price: this.formShop.price,
              stock: this.formShop.stock,
              unitName: this.formShop.unitName
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.formShop = {
                  name: '',
                  unitName: '',
                  stock: '',
                  price: '',
                  dtl: '',
                  imageUpload: ''
                }
                this.fileList = []
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      console.log(params)
      console.log(file1)
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error('只能上传图片格式png、jpg、gif!')
        return
      }
      if (!isLt2M) {
        this.$message.error('只能上传图片大小小于2M')
        return
      }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        this.imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: this.imageUrl,
          path: 'BackstageShop'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            _self.formShop.imageUpload = res.data
            _self.fileList[0] = res.data
          }
        })
      }
    },
    // 删除文件之前的钩子
    handleRemove() {
      _self.fileList = []
    },
    // 文件超出个数限制时的钩
    handleExceed() {
      this.$message.error('最高可上传一个图片')
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    background: #fff;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-form {
      width: 60%;
      /deep/ .el-form-item__content {
        .el-input-number {
          width: 100%;
          input {
            text-align: left;
          }
        }
        .addimage {
          height: 100%;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .el-image {
            width: 30px;
            height: 30px;
          }
          .text {
            padding: 0;
            padding-top: 10px;
            width: 100%;
            line-height: normal;
          }
        }
      }
    }
  }
}
</style>
